
import { Component, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import { ClasshourMapUtils } from '@xt/client/utils/classhour-map'
import MapClasshour from '../MapClasshour/index.vue'
import type { Classhour, Material, NormalMaterial, SpriteMaterial } from '@xt/client/utils/classhour-map/types.d'

@Observer
@Component({
  components: {
    MapClasshour
  }
})
export default class CourseMap extends Vue {
  bottomMaterial: Array<Array<Material>> = []
  topMaterial: Array<Array<Material>> = []
  classhours: Array<Classhour> = []

  utils: ClasshourMapUtils | null = null
  timer: null | ReturnType<typeof setInterval> = null

  mapStyle = {
    width: 0,
    height: 0,
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0
  }

  get MapInfo() {
    return this.$store.$courseV2.mapInfo
  }

  get ProductInfo() {
    return this.$store.$courseV2.productInfo
  }

  get outerMapStyle() {
    const styles: string[] = []

    styles.push(`width: ${this.$px2rem(this.mapStyle.width)}`)
    styles.push(`height: ${this.$px2rem(this.mapStyle.height)}`)
    styles.push(`margin-top: ${this.$px2rem(this.mapStyle.marginTop)}`)
    styles.push(`margin-bottom: ${this.$px2rem(this.mapStyle.marginBottom)}`)
    styles.push(`margin-left: ${this.$px2rem(this.mapStyle.marginLeft)}`)

    return styles.join(';')
  }

  get innerMapStyle() {
    const styles: string[] = []

    styles.push(`width: ${this.$px2rem(this.mapStyle.width)}`)
    styles.push(`height: ${this.$px2rem(this.mapStyle.height)}`)

    return styles.join(';')
  }

  getInnerLayerStyle(layerIndex: number) {
    const styles: string[] = []

    styles.push(`width: ${this.$px2rem(this.mapStyle.width)}`)
    styles.push(`height: ${this.$px2rem(this.mapStyle.height)}`)
    styles.push(`z-index: ${layerIndex}`)

    return styles.join(';')
  }

  getAssetImageStyle(asset: NormalMaterial) {
    const styles: string[] = []

    styles.push(`position: absolute`)
    styles.push(`width: ${this.$px2rem(asset.width)}`)
    styles.push(`height: ${this.$px2rem(asset.height)}`)
    styles.push(`top: ${this.$px2rem(asset.top)}`)
    styles.push(`left: ${this.$px2rem(asset.left)}`)

    return styles.join(';')
  }

  getSpriteMaterialStyle(asset: SpriteMaterial) {
    const styles: string[] = []

    styles.push(`position: absolute`)
    styles.push(`width: ${this.$px2rem(asset.self.width)}`)
    styles.push(`height: ${this.$px2rem(asset.self.height)}`)
    styles.push(`top: ${this.$px2rem(asset.top)}`)
    styles.push(`left: ${this.$px2rem(asset.left)}`)
    styles.push(`background: url(${asset.url}) no-repeat ${this.$px2rem(asset.x)} ${this.$px2rem(asset.y)}`)
    styles.push(`background-size: ${this.$px2rem(asset.width)} ${this.$px2rem(asset.height)}`)

    if (asset.clickEventName) {
      styles.push(`cursor: pointer`)
      // 确保元素能接收到点击事件
      styles.push(`pointer-events: all`)
    }

    if (asset.hover) {
      styles.push(`--hover-pos-x: ${this.$px2rem(asset.hover.x)}`)
      styles.push(`--hover-pos-y: ${this.$px2rem(asset.hover.y)}`)
    }

    return styles.join(';')
  }

  getClasshourStyle(classhour: Classhour) {
    const styles: string[] = []

    styles.push(`position: absolute`)

    switch (classhour.directionStyle) {
      case 'top':
        styles.push(`top: ${this.$px2rem(classhour.top)}`)
        break
      case 'bottom':
        styles.push(`bottom: ${this.$px2rem(classhour.bottom)}`)
        break
    }

    styles.push(`left: ${this.$px2rem(classhour.left)}`)

    return styles.join(';')
  }

  handleClickAssetItem(item: SpriteMaterial) {
    if (!item.clickEventName) return

    this.$emit(item.clickEventName)
  }

  created() {
    if (!this.MapInfo || !this.ProductInfo) return

    this.utils = new ClasshourMapUtils(this.MapInfo.classhourList, this.ProductInfo.taskSchedule, {
      // 开课前请准备一直展示，直到学习回顾需要展示的时候将开课前请准备替换为学习回顾入口
      showPrepare: !this.MapInfo.showReview,
      showReview: this.MapInfo.showReview
    })
    const { width, height, marginBottom, marginTop, marginLeft } = this.utils.getTemplateSize()

    this.mapStyle = {
      width,
      height,
      marginTop,
      marginBottom,
      marginLeft
    }

    this.bottomMaterial = this.utils.getBottomMaterialConfigList()
    this.topMaterial = this.utils.getTopMaterialConfigList()
    this.classhours = this.utils.getClasshourConfigList()

    console.log(this.classhours)
  }
  mounted() {
    if (!this.timer) {
      this.timer = setInterval(() => {
        if (this.utils) {
          console.warn('定时器调度')
          this.classhours = this.utils.getClasshourConfigList()
        }
      }, 10_000)
    }
  }
  updated() {}
  destroyed() {
    if (this.timer) {
      clearTimeout(this.timer)
    }
  }
}
